/*
This file has all the authentification request needed for the register and login
*/
import http, { scheduleAutoLogout } from "./http-common";
import axios from "axios";
import { commentoURL } from "../config/settings-network.mjs";
class AuthService {
  //Send the login credential to the backend and return/store the user info in the localStorage
  //Used in :
  //auth.module
  login(user) {
    return http.post("/api/auth/signin", user).then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("microsoft", false);
        scheduleAutoLogout();
      }
      return response.data;
    });
  }

  loginSSO(user) {
    return http.post("/cas/signin", user).then((response) => {
      if (response.data.accessToken) {
        console.log("loginSSO response.data.accessToken", response);
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("microsoft", false);
        scheduleAutoLogout();
      }
      return response.data;
    });
  }

  loginSimulateSSO(userData) {
    return http.post("/api/auth/simulate-sso", userData).then((response) => {
      if (response.data.accessToken) {
        console.log("response.data.accessToken", response.data.accessToken);
        localStorage.setItem("user", JSON.stringify(response.data));
        scheduleAutoLogout();
      }
      return response.data;
    });
  }

  loginMicrosoft(user) {
    return http.post("/api/auth/signinStudent", user).then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("microsoft", false);
        localStorage.setItem("student", true);
        scheduleAutoLogout();
      }
      return response.data;
    });
  }

  loginStudent(user) {
    return http.post("/api/auth/signinMicrosoft", user).then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("microsoft", false);
        scheduleAutoLogout();
      }
      return response.data;
    });
  }

  //Used in :
  //auth.module
  logout(user) {
    return http.post("/api/auth/logout", user);
  }

  // Send the user information to sign-up
  //Used in :
  //auth.module
  register(user) {
    return http.post("/api/auth/signup", user);
  }

  registerMicrosoft(user) {
    return http.post("/api/auth/signupMicrosoft", user);
  }

  registerStudent(user) {
    return http.post("/api/auth/signupStudent", user);
  }

  //Used in :
  //auth.module
  forgetPassword(user) {
    return http.post("/api/auth/forgetPassword", user);
  }

  //Used in :
  //auth.module
  changePassword(user) {
    return http.post("/api/auth/changePassword", user);
  }

  //Used in :
  //Verify
  verifyAccount(activationKey) {
    return http.get(`/api/auth/verifyAccount${activationKey}`);
  }

  //allow access to all public content (no account needed)
  //Used in :
  //Home
  getPublicContent() {
    return http.get("/api/auth/all");
  }

  //allow access to User board (account needed)
  //Used in :
  //BoardUser
  getUserBoard() {
    return http.get("/api/auth/user");
  }

  //allow access to Subscriber board (account + subscriber role needed)
  //Used in :
  //BoardSubscriber
  getSubscriberBoard() {
    return http.get("/api/auth/sub");
  }

  //allow access to Admin board (account + admin role needed)
  //Used in :
  //BoardAdmin
  getAdminBoard() {
    return http.get("/api/auth/admin");
  }

  /**
   * Get a token to connect to commento.
   * Use axios directly because doesn't need specific headers (otherwise CORS issues)
   * @returns token (10minutes availability long)
   */
  getCommentoToken() {
    return axios.get(commentoURL + "/api/commenter/token/new");
  }

  /**
   * Redirect the same token received by getCommentToken to confirm its us.
   * Use axios directly because doesn't need specific headers (otherwise CORS issues)
   * @returns token (10minutes availability long)
   */
  redirectCommentoToken(params) {
    return axios.get(commentoURL + "/api/oauth/sso/redirect", { params });
  }

  /**
   * Finalize commento verification in the backend
   * Use axios directly because doesn't need specific headers (otherwise CORS issues)
   * @returns token (10minutes availability long)
   */
  finalizeCommento(params) {
    return http.get("/api/auth/sso/commento/finalize", { params });
  }

  endDiscourseSession(user_id) {
    console.log("endDiscourseSession");

    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Api-Username": "AdminELEDA",
        "Api-Key":
          "238c9221de99f561c99c043f17746dcb40996c9cf84b1470502781b678643975",
      },
    };

    axios
      .post(
        "https://forum.eleda.community/admin/users/" + user_id + "/log_out",
        axiosConfig
      )
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  }
}

export default new AuthService();
